import {
  getCurrentHostname,
  getSharedAuthCookieDomain,
  isHubHostname,
  isLocalHostname,
  normalizeHostname,
} from "./tenantHost";

export const LOGGED_OUT_PARAM = "loggedOut";

/**
 * Tenant hosts log out onto the shared hub. Dev tenants
 * (`tojeh.dev.routeeye.io`) return to `dev.routeeye.io`. Other tenant hosts
 * return to `app.routeeye.io`. Hub and localhost stay in the current app.
 */
export function resolveHubLogoutUrl(hostname = getCurrentHostname()) {
  const host = normalizeHostname(hostname);
  if (!host || isLocalHostname(host) || isHubHostname(host)) return "";

  if (host.endsWith(".dev.routeeye.io")) {
    return `https://dev.routeeye.io/?${LOGGED_OUT_PARAM}=1`;
  }

  if (host.endsWith(".routeeye.io")) {
    return `https://app.routeeye.io/?${LOGGED_OUT_PARAM}=1`;
  }

  return "";
}

export function clearAuthCookie() {
  if (typeof document === "undefined") return;
  const domain = getSharedAuthCookieDomain();
  const expires = "Thu, 01 Jan 1970 00:00:00 UTC";
  document.cookie = `token=; expires=${expires}; path=/;`;
  if (domain) {
    document.cookie = `token=; expires=${expires}; path=/; domain=${domain};`;
  }
}

export function clearClientSession() {
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (_error) {
    /* storage can throw in private mode */
  }
  clearAuthCookie();
}

/** Drop a leftover hub session when logout lands as `/?loggedOut=1`. */
export function consumeLoggedOutRequest() {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search || "");
  if (params.get(LOGGED_OUT_PARAM) !== "1") return false;

  clearClientSession();
  params.delete(LOGGED_OUT_PARAM);
  const search = params.toString();
  const next = `${window.location.pathname}${search ? `?${search}` : ""}${
    window.location.hash || ""
  }`;
  window.history.replaceState(null, "", next || "/");
  return true;
}

/**
 * Leave a tenant host for the hub login page.
 * Returns false when logout should stay on the current origin.
 */
export function redirectToHubAfterLogout() {
  const url = resolveHubLogoutUrl();
  if (!url || typeof window === "undefined") return false;
  clearClientSession();
  window.location.replace(url);
  return true;
}
